import LimitedInventoryVehicleModal from './LimitedInventoryVehicleModal';

export default LimitedInventoryVehicleModal;
